import React, { forwardRef, useLayoutEffect, useState } from "react";
import Popper from "@material-ui/core/Popper";

// Autocomplete v4 uses clientWidth, which excludes the panel's CSS zoom.
// Its portal lives outside that zoom, so it needs the field's visual width.
const FitAutocompletePopper = forwardRef(function FitAutocompletePopper({ anchorEl, style, ...props }, ref) {
  const [width, setWidth] = useState();
  useLayoutEffect(() => {
    const anchor = typeof anchorEl === "function" ? anchorEl() : anchorEl;
    if (!anchor) return undefined;
    let frame;
    const measure = () => setWidth(anchor.getBoundingClientRect().width);
    const schedule = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(measure);
    };
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(schedule) : null;
    if (observer) observer.observe(anchor);
    window.addEventListener("resize", schedule);
    measure();
    return () => {
      if (observer) observer.disconnect();
      window.cancelAnimationFrame(frame);
      window.removeEventListener("resize", schedule);
    };
  }, [anchorEl]);
  return <Popper {...props} ref={ref} anchorEl={anchorEl} style={{ ...style, ...(width > 0 ? { width } : {}) }} />;
});

export default FitAutocompletePopper;
